import { apiSlice } from "../../app/api/apiSlice";

export const formApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getBundles: builder.mutation({
            query: (request) => ({
                url: `/form/getBundles`,
                method: 'POST',
                body: {
                    ...request
                }
            })
        }),
        saveForm: builder.mutation({
            query: (request) => ({
                url: '/form/save',
                method: 'POST',
                body: {
                    ...request
                }
            })
        }),
        getForm: builder.mutation({
            query: (request) => ({
                url: '/form',
                method: 'POST',
                body: {
                    ...request
                }
            })
        }),
        generateForm: builder.mutation({
            query: (request) => ({
                url: '/form/generate',
                method: 'POST',
                body: {
                    ...request
                }
            })
        }),
        downloadForm: builder.mutation({
            query: (request) => ({
                url: '/form/download',
                method: 'POST',
                responseHandler: ((response) => response.blob()),
                cache: "no-cache",
                body: {
                    ...request
                },
            })
        }),
        requestDownloadForms: builder.mutation({
            query: (request) => ({
                url: '/form/download/request',
                method: 'POST',
                body: {
                    ...request
                }
            })
        }),
        getReadyForApprovalRequests: builder.mutation({
            query: () => ({
                url: `/form/download/readyForApproval`,
                method: 'GET'
            })
        }),
        getDownloadLinks: builder.mutation({
            query: id => ({
                url: `/form/download/downloadLinks/${id}`,
                method: 'GET'
            })
        }),
        approve: builder.mutation({
            query: id => ({
                url: `/form/download/approve/${id}`,
                method: 'POST'
            })
        }),
        reject: builder.mutation({
            query: id => ({
                url: `/form/download/reject/${id}`,
                method: 'POST'
            })
        }),
        getActiveDownloadRequests: builder.mutation({
            query: (request) => ({
                url: '/form/download/getActiveDownloadRequests',
                method: 'POST',
                body: {
                    ...request
                }
            })
        }),
        getDocuSignAccount: builder.mutation({
            query: userId => ({
                url: `/connect/docusign/connected/${userId}`,
                method: 'GET'
            })
        }),
        connectDocusign: builder.mutation({
            query: userId => ({
                url: `/connect/docusign/authUrl/${userId}`,
                method: 'GET'
            })
        }),
        getDocuSignProcessingRequest: builder.mutation({
            query: (request) => {
                let url = `/form/docusign/processing/${request.userId}?type=${request.type}`
                if(request.clientId) {
                    url = url + `&clientId=${request.clientId}`
                }

                return {
                    url: url,
                    method: 'GET'
                };
              }
        }),
        requestBulkDocusign: builder.mutation({
            query: (request) => ({
                url: '/form/docusign/request/bulk',
                method: 'POST',
                body: {
                    ...request
                }
            })
        }),
        completeDocusignRequest: builder.mutation({
            query: id => ({
                url: `/form/docusign/complete/${id}`,
                method: 'POST'
            })
        }),
        getClientDocusignForms: builder.mutation({
            query: clientId => ({
                url: `/form/docusign/client/documents/${clientId}`,
                method: 'GET'
            })
        }),
        requestIndividualDocusign: builder.mutation({
            query: (request) => ({
                url: '/form/docusign/request/individual',
                method: 'POST',
                body: {
                    ...request
                }
            })
        }),
    })
})

export const { 
    useGetBundlesMutation,
    useSaveFormMutation,
    useGetFormMutation,
    useGenerateFormMutation,
    useRequestDownloadFormsMutation,
    useGetReadyForApprovalRequestsMutation,
    useGetDownloadLinksMutation,
    useApproveMutation,
    useRejectMutation,
    useGetActiveDownloadRequestsMutation,
    useDownloadFormMutation,
    useGetDocuSignAccountMutation,
    useGetDocuSignProcessingRequestMutation,
    useRequestBulkDocusignMutation,
    useCompleteDocusignRequestMutation,
    useGetClientDocusignFormsMutation,
    useRequestIndividualDocusignMutation,
    useConnectDocusignMutation
} = formApiSlice